import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import bigHouseLogo from '../Assets/images/Gap-Realty.png';
import BookScheduleModal from "./Forms/BookSchedule";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isScheduleOpen, setIsScheduleOpen] = useState(false);

  useEffect(() => {
    if (!isHome) {
      setIsScrolled(true);
      return;
    }

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHome]);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleNav = (path) => {
    navigate(path);
    setIsDrawerOpen(false);
  };

  const openSchedule = () => {
    setIsScheduleOpen(true);
    setIsDrawerOpen(false);
  };

  const closeSchedule = () => {
    setIsScheduleOpen(false);
  };

  return (
    <>
      <header className={`luxury-header ${isScrolled ? "scrolled" : ""}`}>
        <div className="luxury-header-container">
          {/* Logo */}
          <div className="luxury-logo" onClick={() => navigate("/")}>
            <img src={bigHouseLogo} alt="Westerns360" />
          </div>

          {/* onClick={() => handleNav("/about-us")}
onClick={() => handleNav("/our-services")}
onClick={() => handleNav("/my-projects")}
onClick={() => handleNav("/contact-us")} */}

          {/* Desktop Navigation */}
          <nav className="luxury-nav">
            <button onClick={() => handleNav("/")} className="luxury-nav-link">
              Home
            </button>
            
            <button onClick={() => handleNav("/about-us")} className="luxury-nav-link">
              About
            </button>

            <button onClick={() => handleNav("/our-services")} className="luxury-nav-link">
              Services
            </button>
            
            <button onClick={() => handleNav("/my-projects")} className="luxury-nav-link">
              Projects
            </button>

            <button onClick={() => handleNav("/events")} className="luxury-nav-link">
              Events
            </button>
            
            <button onClick={openSchedule} className="luxury-nav-link schedule-link">
              Schedule
            </button> 

            {/*<button onClick={() => handleNav("/blog")} className="luxury-nav-link">
              Blog
            </button>*/}
            
            <button onClick={() => handleNav("/contact-us")} className="luxury-contact-btn">
              Connect
            </button>

            <a href="tel:+918130621777" className="luxury-phone-link">
              <Phone size={16} />
              <span>+91 96190 33222</span>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button className="luxury-menu-btn" onClick={toggleDrawer}>
            {isDrawerOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </header>

      {/* Mobile Drawer */}
      <div className={`luxury-mobile-drawer ${isDrawerOpen ? "open" : ""}`}>
        <div className="luxury-mobile-content">
          <button onClick={() => handleNav("/")} className="luxury-mobile-link">
            Home
          </button>
          
          <button onClick={() => handleNav("/about-us")} className="luxury-mobile-link">
            About
          </button>

          <button onClick={() => handleNav("/our-services")} className="luxury-mobile-link">
            Services
          </button>
          
          <button onClick={() => handleNav("/my-projects")} className="luxury-mobile-link">
            Projects
          </button>

          <button onClick={() => handleNav("/events")} className="luxury-mobile-link">
            Events
          </button>
          
          <button onClick={openSchedule} className="luxury-mobile-link schedule-link">
            Schedule
          </button>
          
          <button onClick={() => handleNav("/contact-us")} className="luxury-mobile-contact">
            Connect
          </button>

          <a href="tel:+918130621777" className="luxury-mobile-phone">
            <Phone size={16} />
            <span>+91 96190 33222</span>
          </a>
        </div>
      </div>

      <BookScheduleModal isOpen={isScheduleOpen} closeSchedule={closeSchedule} />
    </>
  );
};

export default Header;